import { Cookies } from "react-cookie";

export const getSession = (key: string): string => {
    const cookies = new Cookies();
    return cookies.get(key);
}

export const findGetParameter = (parameterName: string) => {
    var result = null,
        tmp = [];
    var items = window.location.search.substr(1).split("&");
    for (var index = 0; index < items.length; index++) {
        tmp = items[index].split("=");
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    }
    return result;
}

export const getRefId = (): string | null => {
    let ref_id = findGetParameter('ref');
    if (ref_id === null) {
        ref_id = getSession('_fprom_ref');
    }

    return ref_id;
}